// frontend/src/services/supabaseClient.js
// Barrel file - re-exports all service modules for backward compatibility
// 
// This file maintains backward compatibility with existing imports.
// All functionality has been modularized into domain-specific files:
// - supabaseCore.js: Core Supabase client singleton
// - eventService.js: Event CRUD operations
// - playerService.js: Player/roster operations
// - sportradarService.js: Sportradar API integration
// - storageService.js: Photo storage operations
// - teamService.js: Team management (admin + public)

// All imports must be at the top (ESLint: import/first)
import { supabase } from './supabaseCore';
import * as eventSvc from './eventService';
import * as playerSvc from './playerService';
import * as sportradarSvc from './sportradarService';
import * as storageSvc from './storageService';
import * as teamSvc from './teamService';

// Re-export core client
export { supabase };

// Compose adminService (backward compatible)
// This maintains the same API as before for all existing consumers
export const adminService = {
  // Event operations
  createEvent: eventSvc.createEvent,
  getAllEvents: eventSvc.getAllEvents,
  updateEvent: eventSvc.updateEvent,
  toggleEventArchiveStatus: eventSvc.toggleEventArchiveStatus,
  uploadEventThumbnail: eventSvc.uploadEventThumbnail,

  // Player operations
  importPlayers: playerSvc.importPlayers,
  setPlayerPhoto: playerSvc.setPlayerPhoto,
  bulkImportRoster: playerSvc.bulkImportRoster,
  globalSearch: playerSvc.globalSearch,
  getRecentPlayers: playerSvc.getRecentPlayers,
  deletePlayer: playerSvc.deletePlayer,

  // Sportradar operations
  getSportradarToken: sportradarSvc.getSportradarToken,
  searchSportradar: sportradarSvc.searchSportradar,
  linkSportradarPlayer: sportradarSvc.linkSportradarPlayer,
  importSportradarPlayer: sportradarSvc.importSportradarPlayer,
  linkExistingPlayer: sportradarSvc.linkExistingPlayer,
  updateSportradarPhoto: sportradarSvc.updateSportradarPhoto,
  getSportradarPhoto: sportradarSvc.getSportradarPhoto,
  storeSportradarPhoto: sportradarSvc.storeSportradarPhoto,

  // Storage operations
  removeBackground: storageSvc.removeBackground,
  copySportradarPhoto: storageSvc.copySportradarPhoto,

  // Team operations (admin-facing)
  createTeam: teamSvc.createTeam,
  deleteTeam: teamSvc.deleteTeam,
  getTeamsForEvent: teamSvc.getTeamsForEvent,
};

// Re-export teamService (backward compatible)
// This maintains the same API as before for all existing consumers
export const teamService = {
  validateAccess: teamSvc.validateAccess,
  getPlayersByTeam: teamSvc.getPlayersByTeam,
  getTeamsByEvent: teamSvc.getTeamsByEvent,
  getAllEvents: teamSvc.getAllEvents,
};